<template>
  <label :class="wrapClasses" :disabled="disabled" :checked="currentValue">
    <input
      type="radio"
      :class="inputClasses"
      :disabled="disabled"
      :checked="currentValue"
      :name="groupName"
      @change="_change"/>
    <span :class="innerClasses">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>
<script>
  import { findComponentUpward } from '../../utils/assist'
  import Emitter from '../../mixins/emitter'
  const PREFIX_RADIO_CLASS = 'form-radio'
  export default {
    name: 'TRadio',
    mixins: [ Emitter ],
    props: {
      value: {
        type: Boolean,
        default: false
      },
      label: {
        type: [ String, Number ]
      },
      disabled: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: '',
        validator (value) {
          return ['lg', 'sm', ''].includes(value)
        }
      }
    },
    data () {
      return {
        currentValue: this.value,
        group: false,
        parent: findComponentUpward(this, 'TRadioGroup')
      }
    },
    computed: {
      wrapClasses () {
        return [
          `${PREFIX_RADIO_CLASS}`,
          {
            [`${PREFIX_RADIO_CLASS}-group-item`]: this.group,
            [`${PREFIX_RADIO_CLASS}--${this.size}`]: !!this.size
          }
        ]
      },
      innerClasses () {
        return `${PREFIX_RADIO_CLASS}__inner`
      },
      inputClasses () {
        return `${PREFIX_RADIO_CLASS}__input`
      }
    },
    mounted () {
      if (this.parent) this.group = true
      if (!this.group) {
        this._updateValue()
      } else {
        this.parent.updateValue()
      }
    },
    created() {
      this.groupName = this.$parent.groupName
    },
    methods: {
      _change (event) {
        if (this.disabled) {
          return false
        }
        if (this.group && this.label !== undefined) {
          this.parent._change({
            value: this.label,
            checked: this.value
          })
        }
        const checked = event.target.checked
        this.currentValue = checked
        this.$emit('input', checked)
        if (!this.group) {
          this.$emit('on-change', checked)
          this.dispatch('TFormItem', 'on-form-change', checked)
        }
      },
      _updateValue () {
        this.currentValue = this.value
      }
    },
    watch: {
      value () {
        this._updateValue()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// radio.vue?049560a4